import { Injectable } from '@angular/core';
import { Subject,BehaviorSubject } from 'rxjs';
import { v1 as uuid } from 'uuid';

import { AppinfoService } from './appinfo.service';
import { CommonRequestService, PagingParam, SuccessResponse } from './common-request.service';
import { CommonTableService } from './common-table.service';
import { Gfo } from './gfo.service';
import { UserService } from './user.service';
import { SocketService, SocketMessageFE, SocketLogs } from './socket.service';
import { AppSettings } from './../app.settings';
import { CommonFunctionService } from './common-function.service';
import { AppLayer, LayerService } from './layer.service';
import { ToastrService } from 'ngx-toastr';
import { AttrIndexService } from './attr-index.service';
import { FilterOption, ModelMenuItemKey } from './main-data.service';
import { AdminService } from './admin.service';

export interface QaRule {
	code: string;
	ruleName: string;
	describLong: string;
	errorLevel: 'CRITICAL' | 'WARNING' | 'INFO';

	exceptionAllowed?: boolean;
	count?: number;
	image?: string;
	scope?: 'INTRA-LAYER' | 'INTER-LAYER';
	type?: string;
}
export interface QaRuleDetail {
	code: string;
	causeFix: string;
	exception: string;
	fields;
}
export interface FishboneState {
	id: 1 | 0 | -1; // 1: built, 0: buildable
	desc: string;
	layers: number[];
}

export type QcType = 'schema' | 'content' | 'fishbone' | 'ALL';
export interface QcEditFilter {
	gly_id: number;
	cols?: string[]; // required in qcDynamic
	keyvals?: string[]; // [uuid1, uuid2...]
	where?: string; // 'id IN (1,2,3)'
}

@Injectable()
export class LayerQcService {

	// Qc messages by processId
	public qcLogs: BehaviorSubject<SocketLogs> = new BehaviorSubject({});
	// Build Topo message by processId
	public topoLogs: BehaviorSubject<SocketLogs> = new BehaviorSubject({});
	//
	public onQcFinish: Subject<{ isError: boolean; customerId?: number; }> = new Subject();

	qaRuleDetails: QaRuleDetail[];

	constructor(
		private toastr: ToastrService,
		private socketService: SocketService,
		private adminService: AdminService,
		private appinfoService: AppinfoService,
		private attrIndexService: AttrIndexService,
		private requestService: CommonRequestService,
		private tableService: CommonTableService,
		private layerService: LayerService,
		private userService: UserService,
		private commonFuncService: CommonFunctionService
	) { }

	// Run QC for all the layers
	// Socket is used for receiving responses
	async qcLayers(layerIds: number[], qcType?: QcType, rules?: string[]) {
		const longTransactionExist = await this.adminService.checkLongTransactions();
		if (longTransactionExist) {
			return;
		}
		const url = AppSettings.serviceRootUrl + 'azgiv/qcLayers';
		const userInfo = this.userService.getUserInfo();
		const body: any = {
				userSubscriptionId: userInfo.userSubId,
				// customerId: this.userService.getCustomerIdByType(),
				userId: userInfo.userId,
				sessionId: this.appinfoService.getSessionUuid(),
				layerIds: JSON.stringify(layerIds)
				// stateCode: this.userService.getSelectedCustomerInfo('stateCode'),
		};
		if (rules && rules.length) {
			body.qcRules = JSON.stringify(rules);
		}
		// if (layerIds) {
		// 	body.layerIds = JSON.stringify(layerIds);
		// }
		if (qcType) {
			body.qcType = qcType
		}
		// if (model) {
		// 	body.model = model;
		// }
		//
		const tempProcessId = uuid();
		this.socketService.onInitProcess.next({
			tempId: tempProcessId,
			processType: 'QC'
		});
		return await new Promise<{processId;}>((resolve, reject) => {
			this.requestService.requestPost(url, body, (rsp) => {
				const processesById = this.qcLogs.getValue();
				const processId = rsp.data.content;
				this.socketService.onInitProcess.next({
					tempId: tempProcessId,
					processId: processId,
					processType: 'Upload'
				});
				const process = this.socketService.registerProcessById(rsp.data.content, processesById);
				this.qcLogs.next(processesById);
				resolve({
					processId: processId
				});
			}, err => reject(err));
		});
	}
		// async qcLayerContent(layerId, editFilter: QcEditFilter) {
		// 	const url = AppSettings.serviceRootUrl + 'azgiv/qcLayerContent';
		// 	const userInfo = this.userService.getUserInfo();
		// 	const body: any = {
		// 		userSubscriptionId: userInfo.userSubId,
		// 		layerId: layerId,
		// 		editFilter: JSON.stringify(editFilter)
		// 	};
		// 	return new Promise<any>((resolve, reject) => {
		// 		this.requestService.requestPost(url, body, rsp => {
		// 			resolve(rsp);
		// 		}, err => reject());
		// 	});
		// }
		// async qcLayerDomain(layerId, editFilter: QcEditFilter) {
		// 	const url = AppSettings.serviceRootUrl + 'azgiv/qcLayerDomain';
		// 	const userInfo = this.userService.getUserInfo();
		// 	const body: any = {
		// 		userSubscriptionId: userInfo.userSubId,
		// 		layerId: layerId,
		// 		editFilter: JSON.stringify(editFilter)
		// 	};
		// 	return new Promise<any>((resolve, reject) => {
		// 		this.requestService.requestPost(url, body, rsp => {
		// 			resolve(rsp);
		// 		}, err => reject());
		// 	});
		// }
	async qcLayersDynamic(editFilters?: QcEditFilter[]) {
		const url = AppSettings.serviceRootUrl + 'azgiv/qcLayersDynamic';
		const userInfo = this.userService.getUserInfo();
		const body: any = {
				userSubscriptionId: userInfo.userSubId,
				// customerId: this.userService.getCustomerIdByType(),
				// userId: userInfo.userId,
				// stateCode: this.userService.getSelectedCustomerInfo('stateCode'),
				// layerId: layerId
		};
		// if (qcType) {
		// 	body.qcType = qcType
		// }
		if(editFilters) {
			body.editFilters = JSON.stringify(editFilters);
		}
		return new Promise<any>((resolve, reject) => {
			this.requestService.requestPost(url, body, rsp => {
				resolve(rsp);
			}, err => reject());
		});
	}
	async qcLayerIncNag(nctNames: string[]) {
		const url = AppSettings.serviceRootUrl + 'azgiv/qcLayerIncNag';
		const userInfo = this.userService.getUserInfo();
		const body: any = {
			nctNames: JSON.stringify(nctNames),
			userSubscriptionId: userInfo.userSubId
		};
		return new Promise<{processId;}>((resolve, reject) => {
			this.requestService.requestPost(url, body, (rsp) => {
				console.log('qcLayerIncNag results: ', rsp);
				resolve(rsp);
			}, err => reject(err));
		});
	}

	// Get qc feature report
	getQcFeatureReport(glyId: number, qaCodes: string[], gfo?: Gfo, paging?: PagingParam, sortColumns?: string[], model?: ModelMenuItemKey) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/qcIntraLayerReport';
			const params: any = {
				glyId: glyId.toString(),
			};
			if (qaCodes && qaCodes.length) {
				params.qaCodes = JSON.stringify(qaCodes);
			}
			if (gfo) {
				params.gfo = JSON.stringify(gfo);
			}
			if (!paging) {
				paging = {
					pageSize: this.tableService.defaultTableConfig.pageSize
				};
			} else if (!paging.pageSize) {
				paging.pageSize = this.tableService.defaultTableConfig.pageSize;
			}
			if (sortColumns && sortColumns.length) {
				params.sortColumns = JSON.stringify(sortColumns);
			}
			// model = model || 'N'; // TODO: remove this after Bo fix fishbone filter
			if (model) {
				params.model = model;
			}
			this.requestService.setParamsPaging(params, paging);
			this.requestService.requestGet(url, {
				params: params
			}, (rsp) => {
				resolve(rsp);
			}, async err => {
				// await this.layerService.checkLayerNotFoundError(err, cusId, glyId);
				reject(err);
			});
		});
	}
	// Get qc schema report
	async getQcSchemaReport(layerId: number, qaCodes?: string[], gfo?: Gfo) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/qcSchemaReport';
			const params: any = {
				layerId: layerId.toString()
			};
			if (qaCodes && qaCodes.length) {
				params.qaCodes = JSON.stringify(qaCodes);
			}
			if (gfo) {
				params.gfo = JSON.stringify(gfo);
			}
			this.requestService.setParamsPaging(params, {
				pageNumber: 1,
				pageSize: 200,
				rowCount: 0
			});
			this.requestService.requestGet(url, {
				params: params
			}, (rsp) => {
				resolve(rsp);
			}, err => reject(err));
		});
	}
	// Get qc layer report
	async getQcLayerReport(layerId: number) {
		return new Promise<SuccessResponse<any>>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/qcLayerReport';
			this.requestService.requestGet(url, {
				params: {
					layerId: layerId
				}
			}, (rsp) => {
				resolve(rsp);
			}, err => reject(err));
		});
	}
	getQaRules(customerId: number, layerType?: string, layerId?: number, layerId1?, layerId2?, sortByProperty?: string) {
		return new Promise<QaRule[]>((resolve, reject) => {
			// resolve([]);
			// return;
			const url = AppSettings.serviceRootUrl + 'azgiv/qaRules';
			const params: any = {
				// customerId: customerId.toString()
			};
			if (layerId || layerId === 0) {
				params.layerId = layerId;
			}
			if (layerId1 || layerId1 === 0) {
				params.layerId1 = layerId1;
			}
			if (layerId2 || layerId2 === 0) {
				params.layerId2 = layerId2;
			}
			if (layerType) {
				params.interLayerReport = layerType;
			}
			this.requestService.requestGet(url, {
				params: params
			}, (rsp: any) => {
				const qaRules: QaRule[] = [];
				if (rsp.data) {
					rsp.data.forEach((d) => {
						qaRules.push({
							code: d.gqr_cd,
							describLong: d.gqr_desc_long,
							errorLevel: d.gqr_err_level,
							exceptionAllowed: d.gqr_exception, // TODO
							count: d.cnt,
							image: d.gqr_image,
							scope: d.gqr_scope,
							type: d.gqr_type,
							ruleName: d.gqr_name
						});
					});
					sortByProperty = sortByProperty || 'name';
					qaRules.sort((a, b) => {
						if (a[sortByProperty] < b[sortByProperty]) {
							return -1
						} else if (a[sortByProperty] > b[sortByProperty]) {
							return 1;
						} else {
							return 0;
						}
					});
				}
				resolve(qaRules);
			}, err => reject(err));
		});
	}
	sortFilterByCount = (a, b) => {
		if (a.count && b. count) {
			return 0;
		} else if (a.count) {
			return -1;
		} else {
			return 1;
		}
	}
	// Get all qa rules with detailed cause
	getAllQaRulesWithDetail() {
		return new Promise<QaRuleDetail[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/qaRules';
			this.requestService.requestGet(url, {}, (rsp: any) => {
				const qaRules: QaRuleDetail[] = [];
				if (rsp.data) {
					rsp.data.forEach((d) => {
						qaRules.push({
							code: d.gqr_cd,
							causeFix: d.gqr_cause_fix,
							fields: d.gqr_fields,
							exception: d.gqr_exception
							// describLong: d.gqr_desc_long,
							// errorLevel: d.gqr_err_level,
							// count: d.cnt,
							// image: d.gqr_image,
							// scope: d.gqr_scope,
							// type: d.gqr_type,
							// ruleName: d.gqr_name
						});
					});
				}
				this.qaRuleDetails = qaRules;
				resolve(qaRules);
			}, err => reject(err));
		});
	}
	buildTopology(customerId: number, userId: number, userSubId: number, successCallback?, errorCallback?) {
		const url = AppSettings.serviceRootUrl + 'azgiv/topology';
		const body = {
			customerId: customerId,
			userId: userId,
			userSubscriptionId: userSubId,
			sessionId: this.appinfoService.getSessionUuid()
		};

		// fake a processId for the pop up logs dialogue window
		const tempProcessId = uuid();
		this.socketService.onInitProcess.next({
			tempId: tempProcessId,
			processType: 'TOPO'
		});
		this.requestService.requestPost(url, body, (rsp) => {
			const processesById = this.topoLogs.getValue();
			this.socketService.onInitProcess.next({
				tempId: tempProcessId,
				processId: rsp.data.content,
				processType: 'TOPO'
			});
			this.socketService.registerProcessById(rsp.data.content, processesById);
			this.qcLogs.next(processesById);
			// if (successCallback) {
			// 	successCallback(rsp);
			// }
		}, errorCallback);
	}
	getQcFeatureReportQuery(glyId: number, qaCodes?: string[], gfo?: Gfo, includeGeom?: boolean, model?: ModelMenuItemKey) {
		return new Promise<{sql: string; sql_filter: string; cols?: string; pkey?: string}>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/qcIntraLayerReportQuery';
			const params: any = {
				glyId: glyId.toString(),
				includeGeom: includeGeom
			};
			if (qaCodes && qaCodes.length) {
				params.qaCodes = JSON.stringify(qaCodes);
			}
			if (gfo) {
				params.gfo = JSON.stringify(gfo);
			}
			if (model) {
				params.model = model;
			}
			this.requestService.requestGet(url, {
				params: params
			}, (rsp) => {
				resolve(rsp.data);
			}, err => reject(err));
		});
	}
	// Get the qc error count for a layer
	getQcErrorCount(layerId): Promise<number> {
		return new Promise<number>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/qcErrorCount';
			this.requestService.requestGet(url, {
				params: {
					glyId: layerId
				}
			}, (rsp) => {
				resolve(rsp.data[0]);
			}, err => reject(err));
		});
	}
	// Submit layer to parent agency
	submitLayer(layer: AppLayer, parentEmails: string) {
		return new Promise<number>(async (resolve, reject) => {
			// Get parent agency info
			const url = AppSettings.serviceRootUrl + 'azgiv/submitLayer';
			const body = {
					glyId: layer.id,
					userSubscriptionId: this.userService.getUserInfo().userSubId,
					layerName: layer.name,
					definedBy: layer.category.definedBy,
					category: layer.category.name,
					email: parentEmails
			};
			this.requestService.requestPost(url, body, (rsp) => {
				resolve(rsp);
			}, err => reject(err));
		});
	}
	getSubmitStatus(layerId: number) {
		return new Promise<{ hasError: boolean; msg: string; }>(async (resolve, reject) => {
			// Get parent agency info
			const url = AppSettings.serviceRootUrl + 'azgiv/submitStatus';
			this.requestService.requestGet(url, {
				params: {
					// customerId: this.userService.selectedCustomerId,
					layerId: layerId
				}
			}, rsp => resolve({
				hasError: rsp.data.val,
				msg: rsp.data.msg
			}), err => reject(err));
		});
	}
	getQcCellClassName(colNotes, exceptionsByCol, colProp: string, qcFilterOptions: FilterOption[]) {
		let qcClass = '';
		// let isAllErrorsExcepted = false;
		// if (exceptionsByCol && exceptionsByCol[colProp]) {
		// 	isAllErrorsExcepted = !colNotes.find(i => !exceptionsByCol[colProp][i.cd]);
		// }
		// if (isAllErrorsExcepted) {
		// 	qcClass = 'qc-exception-cell';
		// } else {
			if (exceptionsByCol && exceptionsByCol[colProp]) {
				if (!colNotes) {
					qcClass = 'qc-exception-cell';
					return qcClass;
				}
			}
			if (colNotes) {
				const featureOptions = qcFilterOptions.filter((o) => colNotes.find(c => o.value === c.cd));
				const errorLevels = featureOptions.map(o => o.errorLevel);
				if (errorLevels.indexOf('CRITICAL') > -1) {
					qcClass = 'qc-error-cell';
				} else if (errorLevels.indexOf('WARNING') > -1) {
					qcClass = 'qc-warning-cell';
				}
			}
		// }
		return qcClass;
	}
	getQcErrorLevelCellClassName(errorLevel) {
		let qcClass: string;
		if (errorLevel === 'CRITICAL') {
			qcClass = 'qc-error-cell';
		} else if (errorLevel === 'WARNING') {
			qcClass = 'qc-warning-cell';
		}
		return qcClass;
	}

// Inter Layer
	// buildFishboneAnalysis(cusId, usbId) {
	// 	return new Promise<FishboneState>((resolve, reject) => {
	// 		const url = AppSettings.serviceRootUrl + 'azgiv/fishboneAnalysis';
	// 		this.requestService.requestPost(url, {
	// 			customerId: cusId,
	// 			userSubscriptionId: usbId,
	// 			sessionId: this.appinfoService.getSessionUuid()
	// 		}, (rsp: any) => {
	// 			console.log(rsp);
	// 		}, err => reject(err));
	// 	});
	// }
	getFishboneState(customerId, model?: ModelMenuItemKey) {
		return new Promise<FishboneState>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/fishboneState';
			const params: any = {
				customerId: customerId
			};
			if (model) {
				params.model = model;
			}
			this.requestService.requestGet(url, {
				params: params
			}, (rsp: any) => {
				const data = rsp.data;
				resolve({
					id: data.state_id,
					desc: data.state_desc,
					layers: data.layers
				});
			}, err => reject(err));
		});
	}
	// TODO: Remove the following services
			getQcInterLayerReportByAttr(customerId, reportType: string, qaCodes?: string[], gfo?: Gfo, paging?: PagingParam, sortColumns?: string[]) {
				return new Promise<any>((resolve, reject) => {
					const url = AppSettings.serviceRootUrl + 'azgiv/qcInterLayerReportByAttr';
					const params: any = {
						customerId: customerId,
						reportType: reportType
					};
					if (qaCodes) {
						params.qaCodes = JSON.stringify(qaCodes);
					}
					if (gfo) {
						params.gfo = JSON.stringify(gfo);
					}
					if (!paging) {
						paging = {
							pageSize: this.tableService.defaultTableConfig.pageSize
						};
					} else if (!paging.pageSize) {
						paging.pageSize = this.tableService.defaultTableConfig.pageSize;
					}
					if (sortColumns && sortColumns.length) {
						params.sortColumns = JSON.stringify(sortColumns);
					}
					this.requestService.setParamsPaging(params, paging);
					this.requestService.requestGet(url, {
						params: params
					}, (rsp) => {
						resolve(rsp);
					}, err => reject(err));
				});
			}
			getQcInterLayerReportByMap(customerId, reportType: string, bbox: number[], qaCodes?: string[], gfo?: Gfo, sortColumns?: string[]) {
				return new Promise<any>((resolve, reject) => {
					const url = AppSettings.serviceRootUrl + 'azgiv/qcInterLayerReportByMap';
					const params: any = {
						customerId: customerId,
						reportType: reportType,
						bbox: JSON.stringify(bbox)
					};
					if (qaCodes) {
						params.qaCodes = JSON.stringify(qaCodes);
					}
					if (gfo) {
						params.gfo = JSON.stringify(gfo);
					}
					if (sortColumns && sortColumns.length) {
						params.sortColumns = JSON.stringify(sortColumns);
					}
					this.requestService.requestGet(url, {
						params: params
					}, (rsp) => {
						if (rsp && rsp.data) {
							// Sort so that FSA/FSB will draw before FS1/FS3
							rsp.data.sort((a, b) => {
								if (!b.qa_notes || !b.qa_notes.cd) {
									return -1
								} else if (!a.qa_note || !a.qa_notes.cd) {
									return 1;
								} else {
									if (a.qa_notes.cd < b.qa_notes.cd) {
										return 1
									} else if (a.qa_notes.cd > b.qa_notes.cd) {
										return -1;
									} else {
										return 0;
									}
								}
							})
						}
						resolve(rsp);
					}, err => reject(err));
				});
			}
			getQcInterLayerReportByAttrQuery(customerId, reportType: string, qaCodes?: string[], gfo?: Gfo) {
				return new Promise<string>((resolve, reject) => {
					const url = AppSettings.serviceRootUrl + 'azgiv/qcInterLayerReportByAttrQuery';
					const params: any = {
						customerId: customerId,
						reportType: reportType
					};
					if (qaCodes) {
						params.qaCodes = JSON.stringify(qaCodes);
					}
					if (gfo) {
						params.gfo = JSON.stringify(gfo);
					}
					this.requestService.requestGet(url, {
						params: params
					}, (rsp) => {
						resolve(rsp.data.sql);
					}, err => reject(err));
				});
			}
			buildFishbone() {
				const layer = this.layerService.layerListBS.getValue().layers.find(l => l.category && l.category.code === this.attrIndexService.cateCodeAddress);
				if (layer && layer.id) {
					this.qcLayers([layer.id], 'fishbone');
				} else {
					this.toastr.info('Address layer not found');
				}
			}
}
